import { render, staticRenderFns } from "./medicalErrorLog.vue?vue&type=template&id=2acc8f87&scoped=true"
import script from "./medicalErrorLog.vue?vue&type=script&lang=js"
export * from "./medicalErrorLog.vue?vue&type=script&lang=js"
import style0 from "./medicalErrorLog.vue?vue&type=style&index=0&id=2acc8f87&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acc8f87",
  null
  
)

export default component.exports